import { generateApiPath } from '@scouts/helpers'

import { SocialSecurityProfileDTO, SocialSecurityProfileEditDTO } from '@/models'

import { apiSlice } from '../api-slice'
import { ENDPOINTS } from '../endpoints'
import { ApiTags } from '../tags'

const extendedApi = apiSlice.injectEndpoints({
    endpoints: (builder) => ({
        getSocialSecurityProfile: builder.query<SocialSecurityProfileDTO, { userId?: number }>({
            query: ({ userId }) => ({
                method: 'GET',
                url: generateApiPath(ENDPOINTS.SOCIAL_SECURITY_PROFILE.GET, { userId }),
            }),
            providesTags: [ApiTags.SocialSecurityProfile],
        }),
        updateSocialSecurityProfile: builder.mutation<
            SocialSecurityProfileDTO,
            Partial<SocialSecurityProfileEditDTO> & { userId?: number }
        >({
            query: (data) => ({
                method: 'PUT',
                url: generateApiPath(ENDPOINTS.SOCIAL_SECURITY_PROFILE.PUT, { userId: data.userId }),
                data,
            }),
            invalidatesTags: [ApiTags.SocialSecurityProfile],
        }),
    }),
})

export const { useGetSocialSecurityProfileQuery, useUpdateSocialSecurityProfileMutation } = extendedApi

export const invalidateSocialSecurityProfile = () => apiSlice.util.invalidateTags([ApiTags.SocialSecurityProfile])
